import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f89fbdc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "components__rec-causes-selector" }
const _hoisted_2 = { class: "causes-container" }
const _hoisted_3 = ["onUpdate:modelValue", "disabled"]
const _hoisted_4 = ["name", "value"]

import { recProps } from '../../mixins/rec-component';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'rec-causes-selector',
  props: {...recProps()},
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, _toDisplayString(_ctx.description.explanation_text), 1),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.description.causes, (subapt) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "causes-entry",
          key: subapt.id
        }, [
          _createElementVNode("label", null, [
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": ($event: any) => ((subapt.checked) = $event),
                disabled: _ctx.description.disabled
              }, null, 8, _hoisted_3), [
                [_vModelCheckbox, subapt.checked]
              ])
            ]),
            _createElementVNode("div", null, _toDisplayString(subapt.label), 1)
          ]),
          (subapt.checked)
            ? (_openBlock(), _createElementBlock("input", {
                key: 0,
                type: "hidden",
                name: _ctx.description.name,
                value: subapt.id
              }, null, 8, _hoisted_4))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}
}

})